export default __webpack_public_path__ + "static/media/splash3.088ba7b6.png";